import React, { useState, useEffect, useMemo } from "react";
import axios from "../config/axios";
import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import TopBanner from "../components/aboutPartials/TopBanner";
import AboutDescriptionSection from "../components/aboutPartials/AboutDescriptionSection";
import { useLocation } from "react-router-dom";
import { useGeneral } from "../components/contexts/GeneralContext";
import FullScreenLoading from "../components/common/loading/FullScreenLoading";
import ApiErrorMessage from "../components/common/ApiErrorMessage";
import NoItemsFound from "../components/common/NoItemsFound";
const usePageContent = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState([]);
  const [error, setError] = useState("");
  const { discountCoupons, setExtraContent } = useGeneral();

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const { data } = await axios.get("page-content/about-us");
        if (active) setContent(data);
        setExtraContent((prev) => ({
          ...prev,
          socialChannels: data?.socialChannels,
          whatsAppNumber: data?.whatsAppNumber,
        }));
      } catch (err) {
        console.error(err);
        if (active) setError("Failed to load plans. Please try again later.");
      } finally {
        if (active) setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return { content, loading, error, discountCoupons };
};

const AboutPage = () => {
  const { content, loading, error, discountCoupons } = usePageContent();

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const activeSection = React.useMemo(
    () => query.get("active") || "who",
    [location.search]
  );
  const scroll = React.useMemo(() => query.get("scroll"), [activeSection]);
  const scrollToTop = () => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  };
  const scrollToSection = () => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 500, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  };
  
  useEffect(() => {
    if (activeSection && scroll === "1") {
      const cleanup = scrollToSection();
      return cleanup;
    }
  }, [activeSection, scroll]);

  const memoizedContent = useMemo(() => content, [content]);
  return (
    <>
      {loading && <FullScreenLoading />}
      <PageWrapper loading={true} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />
        <BodyWrapper loading={loading} className="mb-8">
          {error ? (
            <ApiErrorMessage
              message1="Failed to load about us"
              message2="Please check your connection and try again."
            />
          ) : !loading && memoizedContent.length === 0 ? (
            <NoItemsFound
              message1="No content available"
              message2="Please check back later."
            />
          ) : (
            <>
              <TopBanner about={memoizedContent} />
              <AboutDescriptionSection
                content={memoizedContent}
                active={activeSection}
              />
            </>
          )}
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default AboutPage;
